import React, { useEffect, useState } from "react";
import SecurityCard from "../../../../components/cards/SecurityCard";
import { useAppDispatch } from "../../../../redux/app/hooks";
import {
  fetchGeneralSettings,
  fetchKycSettings,
} from "../../../../redux/features/settingsSlice";
import ViewGeneralSettingsModal from "./ViewGeneralSettingsModal";
import ViewKYCSettingsModal from "./ViewKYCSettingsModal";
import EditGeneralSettingsModal from "./EditGeneralSettingsModal";
import EditKycSettingsModal from "./EditKycSettingsModal";
import TransactionFeeModal from "./SetTransactionFeeModal";
import ViewCourierPricingModal from "./ViewCourierFeeSettings";
import { fetchAllCouriers } from "../../../../redux/features/CourrierSlice";
import EditCourierPricingModal from "./EditCourierFeeSettings";

const ConfigurationSettings = () => {
  const [openViewGeneralSettings, setOpenViewGeneralSettings] = useState(false);
  const [openConfigureGeneralSettings, setOpenConfigureGeneralSettings] =
    useState(false);
  const [openViewCourierSettings, setOpenViewCourierSettings] = useState(false);
  const [openConfigureCourierSettings, setOpenConfigureCourierSettings] =
    useState(false);
  const [openViewKYCSettings, setOpenViewKYCSettings] = useState(false);
  const [openConfigureKYCSettings, setOpenConfigureKYCSettings] =
    useState(false);
  const [openTransactionFeeSettings, setOpenTransactionFeeSettings] =
    useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchGeneralSettings());
    dispatch(fetchKycSettings());
    dispatch(fetchAllCouriers({}));
  }, [dispatch]);

  return (
    <div className="bg-white  rounded-3xl ">
      <h2 className="text-lg font-semibold mb-4 border-b border-borderColor py-6 px-6">
        Settings
      </h2>
      <div className="space-y-4 p-6">
        <SecurityCard
          title="General Settings"
          description="Manage your account settings and preferences."
          childTextButtons={
            <div className="flex items-center gap-4">
              <button
                onClick={() => setOpenViewGeneralSettings(true)}
                className="pointer"
              >
                View
              </button>
              <span
                onClick={() => setOpenConfigureGeneralSettings(true)}
                className="pointer"
              >
                Configure
              </span>
            </div>
          }
        />
        <SecurityCard
          title="Courier Settings"
          description="Configure your courier preferences and options."
          childTextButtons={
            <div className="flex items-center gap-4">
              <span
                onClick={() => setOpenViewCourierSettings(true)}
                className="pointer"
              >
                View
              </span>
              <span
                onClick={() => setOpenConfigureCourierSettings(true)}
                className="pointer"
              >
                Configure
              </span>
            </div>
          }
        />
        <SecurityCard
          title="KYC Settings"
          description="Manage your KYC settings and requirements."
          childTextButtons={
            <div className="flex items-center gap-4">
              <span
                onClick={() => setOpenViewKYCSettings(true)}
                className="pointer"
              >
                View
              </span>
              <span
                onClick={() => setOpenConfigureKYCSettings(true)}
                className="pointer"
              >
                Configure
              </span>
            </div>
          }
        />
        <SecurityCard
          title="Transaction Fee Settings"
          description="Set and manage your transaction fees."
          childTextButtons={
            <div className="flex items-center gap-4">
              <span className="pointer">View</span>
              <span
                onClick={() => setOpenTransactionFeeSettings(true)}
                className="pointer"
              >
                Configure
              </span>
            </div>
          }
        />
      </div>

      {/* Modals to view settings */}
      <ViewGeneralSettingsModal
        isOpen={openViewGeneralSettings}
        onClose={() => setOpenViewGeneralSettings(false)}
      />
      <ViewKYCSettingsModal
        isOpen={openViewKYCSettings}
        onClose={() => setOpenViewKYCSettings(false)}
      />
      <ViewCourierPricingModal
        isOpen={openViewCourierSettings}
        onClose={() => setOpenViewCourierSettings(false)}
      />

      {/* modal to configure settings */}
      <EditGeneralSettingsModal
        open={openConfigureGeneralSettings}
        onClose={() => setOpenConfigureGeneralSettings(false)}
      />
      <EditKycSettingsModal
        open={openConfigureKYCSettings}
        onClose={() => setOpenConfigureKYCSettings(false)}
      />
      <TransactionFeeModal
        open={openTransactionFeeSettings}
        onClose={() => setOpenTransactionFeeSettings(false)}
      />
      <EditCourierPricingModal
        isOpen={openConfigureCourierSettings}
        onClose={() => setOpenConfigureCourierSettings(false)}
      />
    </div>
  );
};

export default ConfigurationSettings;
